import { render, staticRenderFns } from "./DictionaryManageView.vue?vue&type=template&id=6c715c9c"
import script from "./DictionaryManageView.vue?vue&type=script&lang=js"
export * from "./DictionaryManageView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports